/* unplugin-vue-components disabled */import script from "./utility-contact-us.vue?vue&type=script&lang=js"
export * from "./utility-contact-us.vue?vue&type=script&lang=js"

import "./utility-contact-us.vue?vue&type=style&index=0&id=95e2ae0e&lang=scss"

const __exports__ = script;

export default __exports__